import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Competency, Engagement } from 'src/app/interfaces/home.interface';
import { HomeService } from 'src/app/services/home/home.service';

@Component({
  selector: 'app-engagement-summary',
  templateUrl: './engagement-summary.component.html',
  styleUrls: ['./engagement-summary.component.scss'],
})
export class EngagementSummaryComponent implements OnInit {
  public engagements!: Competency;
  public engagementRevenue: number = 0;
  public engagementId!:any;
  loading: boolean = false;
  public headerList: Array<any> = [
    {
      label: 'Engagement Name',
      colDef: { fieldName: 'engagementName'},
    },
    {
      label: 'Start Date',
      colDef: { fieldName: 'startDate'},
    },
    {
      label: 'Metrics',
      colDef: { fieldName: 'metrics'},
    },
    {
      label: 'Key Contacts',
      colDef: { fieldName: 'keyContacts'},
    },
    {
      label: '',
      colDef: { fieldName: 'action'},
    },
  ];

  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute,
    private router:Router
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.engagementId = id;
    this.loading = true;
    if (id)
      this.homeServiceRef.getEngagements(id).subscribe((res) => {
        this.engagements = res;
        Object.values(res).map((v: any, k, arr) => {
           this.engagementRevenue = v.reduce((acc:number, obj: Engagement) => {
            return acc + obj.revenuePerYear;
           }, this.engagementRevenue)
        });
        this.loading = false;
      });
  }

  redirectEngagementDetails(engagementName:any){
    this.router.navigate([`/engagementdetails`, engagementName, this.engagementId]);
  }
}